import { getTypedTools, SagaContext as Context, SagaHandler as Handler } from "async-saga";
import { processApiError } from "../../api";
import { StoreState } from "../types";
import { createApiActions } from "./api-actions";

export const { take, takeEvery, waitForState } = getTypedTools<StoreState>()
export type SagaContext = Context<StoreState>
export type SagaHandler = Handler<SagaContext>

const { middleware, wireUpApi } = createApiActions((ex, { dispatch }) => processApiError(ex, dispatch))
export { wireUpApi }
export { middleware as apiMiddleware }
